<template>
  <b-modal 
    id="recordingsListModal"
    title="Videos"
    size="xl"
    hide-footer
    @close="$emit('close')"
  >
    <div class="recordings-container">
      <ul 
        v-if="recordings.length"
        class="recordings__list"
      >
        <li 
          v-for="item in recordings"
          :key="item.id"
          class="list-item"
          :class="{ 'active': item.id === uploadedVideoFile }"
        >
          <div class="recordings__list-item">
            <video
              :src="item.url"
              controls
            />
          </div>
          
          <div class="list-item__controls">
            <button
              class="unstyled-btn font-weight-bold"
              @click.stop="() => handleRenameBtn(item)"
            >
              <b-icon icon="pencil" />
            </button>
            <button
              class="unstyled-btn font-weight-bold"
              @click.stop="() => handleDownloadBtn(item.path, item.name)"
            >
              <b-icon icon="download" />
            </button>
            <button
              class="unstyled-btn font-weight-bold"
              @click.stop="() => handleShareBtn(item.id)"
            >
              <b-icon icon="share-fill" />
            </button>
            <button
              class="unstyled-btn font-weight-bold"
              @click.stop="() => $emit('delete', item.id)"
            >
              <b-icon 
                icon="trash" 
                variant="danger"
              />
            </button>
          </div>
          <p class="list-item__name">
            {{ item.name }}.{{ item.type }}
          </p>
        </li>
      </ul>
      
      <div 
        v-else
        class="no-recordings mb-3"
      >
        No records yet
      </div>
      
      <b-pagination
        :value="currentPage"
        :total-rows="total"
        per-page="10"
        @change="(page) => $emit('pageChanged', page)"
      />
    </div>
    
    <ShareLinkModal :share-link="shareLink" />
    <RenameModal 
      :item="currentVideo"
      @change="(name) => $emit('changeName', { id: currentVideo.id, name })"
    />
  </b-modal>
</template>

<script>
import { downloadFileLink } from "@frontend/components/modules/file-browser/helpers";
import FileBrowser from "@frontend/services/api/file-browser";
import ShareLinkModal from "@frontend/components/modules/video-screen-recording/share-link-modal.vue";
import RenameModal from "@frontend/components/modules/video-screen-recording/rename-modal.vue";

export default {
  name: 'RecordingsListModal',
  
  components: {
    RenameModal,
    ShareLinkModal
  },
  
  props: {
    recordings: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    uploadedVideoFile: {
      type: Number,
      default: null
    }
  },
  
  data: () => ({
    shareLink: '',
    currentVideo: null
  }),
  
  methods: {
    handleDownloadBtn(url, name) {
      downloadFileLink(url, name)
    },
    
    async handleShareBtn(id) {
      const { data } = await FileBrowser.createShareLink({
        fileIds: [id],
        mode: 'view',
        type: 'mp4',
        loginRequired: false,
        directLinkToFile: null,
      });

      this.shareLink = `${data.link}?openItem=${id}`;

      this.$bvModal.show('share-link-modal');
    },
    
    handleRenameBtn(item) {
      this.currentVideo = item;
      
      this.$bvModal.show('rename-modal');
    }
  }
}
</script>

<style lang="scss" scoped>
  .recordings__list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 0;
    
    li {
      width: calc(20% - 12px);
      height: 100%;
      list-style: none;
    }
    
    &-item {
      position: relative;
      padding-top: 75%;
      
      video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  .list-item {
    position: relative;
    border: 1px solid;
    border-radius: 10px;
    padding: 5px;
    
    &__controls {
      position: absolute;
      top: 0;
      right: 10px;
      display: flex;
      justify-content: center;
      column-gap: 10px;
    }
    
    &__name {
      text-align: center;
      font-size: 15px;
      margin-bottom: 0;
    }
    
    &.active {
      border: 2px solid #209c86;
      padding: 5px;
      border-radius: 10px;
    }
  }
  
  .no-recordings {
    text-align: center;
    font-size: 18px;
  }
</style>
